import { Injectable } from '@angular/core';
import { Api } from '../api';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class WorkspaceService extends Api {

  constructor(
    readonly http: HttpClient,
    readonly authService: AuthService
    ) {
    super(http, authService, 'workspace');
  }
}
